var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-settings__card"},[_c('h2',{staticClass:"header-2"},[_vm._v(" Informații de facturare ")]),_c('FormBillingInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }